export { CopyButton } from '@mantine/core'